import React from 'react';
import { Button } from './Button';
export function FinalPurchaseSection() {
  return <section className="bg-brand-bg text-brand-text px-4 py-10" data-id="element-49">
      <div className="max-w-xl mx-auto text-center" data-id="element-50">
        <h2 className="text-xl md:text-2xl font-black mb-4 text-yellow" data-id="element-51">
          CIERRE FINAL
        </h2>
        <p className="text-base font-bold text-white mb-3" data-id="element-52">
          La decisión es simple.
        </p>
        <p className="text-sm text-brand-muted leading-relaxed mb-3" data-id="element-53">
          Podés seguir buscando información suelta, perdiendo tiempo y dejando
          pasar oportunidades.
        </p>
        <p className="text-sm text-brand-muted leading-relaxed mb-6" data-id="element-54">
          O podés acceder hoy al sistema más completo de electricidad práctica
          por menos de lo que cuesta una salida.
        </p>

        <Button href="https://master-electrotecnico.impultienda.ar/checkout" data-id="element-55">
          🔥 QUIERO EL MEGA PACK AHORA — $17.90 USD
        </Button>

        <p className="text-sm font-bold text-white mt-4" data-id="element-56">
          ✅ Acceso inmediato — ✅ 6 Bonus incluidos — ✅ Garantía 7 días — ✅
          Pago seguro
        </p>

        <p className="text-xs text-brand-muted mt-4 leading-relaxed" data-id="element-57">
          ⏳ Esta oferta de lanzamiento es por tiempo limitado. El precio puede
          subir en cualquier momento.
        </p>
      </div>
    </section>;
}